import { IValidation } from 'typia'
import { logValidationFailure } from 'components/shared/parsing/parsing.js'

export const validationError = (validationType: string, errors: IValidation.IError[]) => {
  logValidationFailure(validationType, errors)
}
